import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc1afd68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deepexcavation-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-bg" }, null, -1))
const _hoisted_3 = { class: "nav-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基坑数量", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "监测点数量", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预警数量", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报警数量", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span", null, "深基坑实时告警统计")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-1" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "chart-1" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span", null, "深基坑告警统计")
], -1))
const _hoisted_11 = { class: "chart-2" }
const _hoisted_12 = {
  key: 0,
  id: "chart-2"
}
const _hoisted_13 = {
  key: 1,
  class: "zhanweitext"
}
const _hoisted_14 = { class: "tabbar" }
const _hoisted_15 = { class: "middle-text" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "监测信息", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "nav-tab" }
const _hoisted_20 = { class: "tab-container" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "popup"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实时值", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "X方向", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Y方向", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Z方向", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "预警值", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "X方向", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Y方向", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Z方向", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "报警值", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "X方向", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Y方向", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Z方向", -1))
const _hoisted_35 = {
  key: 1,
  class: "popup"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实时值：", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "深度：", -1))
const _hoisted_40 = { key: 2 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预警值：", -1))
const _hoisted_42 = { key: 3 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计位移：", -1))
const _hoisted_44 = { key: 0 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报警值：", -1))
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预警值：", -1))
const _hoisted_48 = { key: 2 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报警值：", -1))
const _hoisted_50 = {
  key: 2,
  class: "zhanwei"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.programTotal ? _ctx.programTotal : 0), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.pointTotal ? _ctx.pointTotal : 0), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_ctx.warnNum ? _ctx.warnNum : 0), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_ctx.alarmNum ? _ctx.alarmNum : 0), 1)
        ])
      ])
    ]),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      (_ctx.flag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无数据"))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        (_ctx.selectList.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.selectList[0].name) + " ", 1),
              _createElementVNode("img", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args))),
                src: require('../highformwork/images/xiala.png')
              }, null, 8, _hoisted_18),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args)))
              }, "切换")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabArray, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass({ currentStyle: index === _ctx.active }),
              onClick: ($event: any) => (_ctx.changeTab(index))
            }, _toDisplayString(item), 11, _hoisted_21))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.resultPicker,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.resultPicker) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: _ctx.resultPickerscolumns,
          "show-toolbar": "",
          "value-key": "name",
          onConfirm: _ctx.resultPickersonConfirm,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resultPicker = false))
        }, null, 8, ["columns", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "vanpopup",
      show: _ctx.show,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.show) = $event)),
      closeable: "",
      round: "",
      position: "bottom",
      style: { height: '75%' }
    }, {
      default: _withCtx(() => [
        (_ctx.active === 0 || _ctx.active === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "pop-list",
                  key: index
                }, [
                  _createElementVNode("div", null, "监测点：" + _toDisplayString(item.pointNo), 1),
                  _createElementVNode("div", null, [
                    _hoisted_23,
                    _createElementVNode("div", null, [
                      _hoisted_24,
                      _createElementVNode("div", null, _toDisplayString(item.x1), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_25,
                      _createElementVNode("div", null, _toDisplayString(item.y1), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_26,
                      _createElementVNode("div", null, _toDisplayString(item.z1), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_27,
                    _createElementVNode("div", null, [
                      _hoisted_28,
                      _createElementVNode("div", null, _toDisplayString(item.warnValue.substr(0, 3)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_29,
                      _createElementVNode("div", null, _toDisplayString(item.warnValue.substr(4, 3)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_30,
                      _createElementVNode("div", null, _toDisplayString(item.warnValue.substr(8, 3)), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_31,
                    _createElementVNode("div", null, [
                      _hoisted_32,
                      _createElementVNode("div", null, _toDisplayString(item.alarmValue.substr(0, 1)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_33,
                      _createElementVNode("div", null, _toDisplayString(item.alarmValue.substr(2, 1)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_34,
                      _createElementVNode("div", null, _toDisplayString(item.alarmValue.substr(4, 1)), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (
          _ctx.active === 2 ||
          _ctx.active === 3 ||
          _ctx.active === 4 ||
          _ctx.active === 5 ||
          _ctx.active === 6
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordList1, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "pop-list1",
                  key: index
                }, [
                  _createElementVNode("div", null, _toDisplayString(item.pointNo), 1),
                  _createElementVNode("div", null, [
                    (_ctx.active !== 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("span", null, _toDisplayString(item.sink), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("span", null, _toDisplayString(item.depth), 1)
                        ])),
                    (_ctx.active !== 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("span", null, _toDisplayString(item.warnValue), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("span", null, _toDisplayString(item.changeAdd), 1)
                        ]))
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.active !== 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("span", null, _toDisplayString(item.alarmValue), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("span", null, _toDisplayString(item.warnValue), 1)
                        ])),
                    (_ctx.active === 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("span", null, _toDisplayString(item.alarmValue), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.recordList.length === 0 && _ctx.recordList1.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, " 暂无数据 "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}